const colors = require('tailwindcss/colors');

module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    'primary': '#0f71b2',
                    'primary-inverse': '#ffffff',
                    'secondary': '#f8b52a',
                    'secondary-inverse': '#ffffff',
                    'accent1': '#eaf4f3',
                    'accent1-inverse': '#0a3b5d',
                    'accent2': '#0a3b5d',
                    'accent2-inverse': '#ffffff',
                },

                neutral: colors.neutral,
                blueGray: colors.slate,
                trueGray: colors.neutral,
                coolGray: colors.gray,
                warmGray: colors.stone,
                red: colors.red,
                orange: colors.orange,
                yellow: colors.yellow,
                lime: colors.lime,
                green: colors.green,
                emerald: colors.emerald,
                teal: colors.teal,
                cyan: colors.cyan,
                lightBlue: colors.sky,
                blue: colors.blue,
                indigo: colors.indigo,
                violet: colors.violet,
                purple: colors.purple,
                fuchsia: colors.fuchsia,
                pink: colors.pink,
                rose: colors.rose,
            },
            borderRadius: {
                '2xl': '16px',
            },
            maxWidth: {
                'container': '1024px',
            },
        },
        fontFamily: {
            sans: ['"VAG Rounded Next"', 'sans-serif'],
        },
        container: {
            center: true,
            padding: '1rem',
            screens: {
                DEFAULT: '1024px',
            },
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
